$("a.mapplic-pin.circle").on("click", function(){
    alert("test");
});
